import { render, staticRenderFns } from "./counseling.vue?vue&type=template&id=276ffa3d&scoped=true"
import script from "./counseling.vue?vue&type=script&lang=js"
export * from "./counseling.vue?vue&type=script&lang=js"
import style0 from "./counseling.vue?vue&type=style&index=0&id=276ffa3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276ffa3d",
  null
  
)

export default component.exports